import { render, staticRenderFns } from "./AwaitingApproval.vue?vue&type=template&id=8b07e068&scoped=true&"
import script from "./AwaitingApproval.vue?vue&type=script&lang=js&"
export * from "./AwaitingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b07e068",
  null
  
)

export default component.exports